import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Logo } from "assets/svg";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import { cleanData, fetchResetPassword } from "reducers/authSlice";
import { useNavigate } from "react-router-dom";

const ForgotPassword: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { resetPasswordData, errorResetPassword } = useSelector(
    (state: RootState) => state.auth,
  );

  const { register, handleSubmit } = useForm({
    defaultValues: { email: "" },
  });

  const onSubmit = (data: any) => {
    dispatch(fetchResetPassword(data.email));
  };

  useEffect(() => {
    if (resetPasswordData?.success) {
      navigate("/sent-mail-reset-password");
    }
    if (errorResetPassword) {
      alert(errorResetPassword.message);
    }
    return () => {
      dispatch(cleanData());
    };
  }, [resetPasswordData, errorResetPassword]);

  return (
    <main className="bg--blur box">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="w-full max-w-[370px] sm:max-w-[500px] rounded-[20px] border-[6px] sm:border-[8px] border-white bg-white/80 shadow-[0_0_15px_0_rgba(0,0,0,0.05)] flex flex-col items-center py-[36px] px-[14px] sm:py-[56px] sm:px-[50px]"
      >
        <Logo className="w-[200px] h-[81px] mb-[16px] sm:w-[300px] sm:h-[121px] sm:mb-[24px]" />
        <h2 className="text-[20px] font-bold text-primary mb-[12px] text-center sm:text-[24px] sm:mb-[18px]">
          パスワードを
          <br className="sm:hidden" />
          お忘れですか？
        </h2>
        <p className="text-[14px] font-normal leading-[160%] text-center mb-[22px] sm:text-[15px] sm:mb-[26px]">
          ご登録のメールアドレスを入力してください。
          <br className="sm:hidden" />
          パスワード再設定用のリンクをお送りします。
        </p>
        <label className="text-[16px] font-bold text-primary mb-[6px] sm:text-[17px] sm:mb-[7px]">
          メールアドレス
        </label>
        <input
          {...register("email", { required: true })}
          type="email"
          className="w-full h-[46px] px-[16px] rounded-[6px] mb-[7px] text-[16px] border border-gray-300 bg-white focus:outline-primary sm:h-[50px] sm:text-[17px]"
          placeholder="sample@example.com"
          required
        />
        <span className="block text-[12px] mb-[18px] sm:text-[13px] sm:mb-[20px]">
          ※登録済みのメールアドレスを入力してください。
        </span>
        <button
          type="submit"
          className="w-full bg-primary text-white py-3 rounded-[6px] text-[16px] font-bold mb-[16px] sm:max-w-[340px] sm:text-[17px] sm:mb-[22px] transition hover:bg-[#103E75]"
        >
          再設定リンクを送信する
        </button>
        <span className="block text-[11px] text-center mb-[2px] sm:text-[12px]">
          ※自動的に10秒後に本登録ページに遷移します。
        </span>
        <span className="block text-[11px] text-center sm:text-[12px]">
          ※登録されていないメールアドレスには送信されません。
        </span>
      </form>
    </main>
  );
};

export default ForgotPassword;
